<div class="table card" [style.height]="heightTable.heightTable">
    <div class="table_wrapper">
        <div class="table_header">
            <div class="row fw_500 fz_m row_ai_center">
                <div *ngFor="let column of columns" [class]="'col-' + column.col">
                    <ng-container *ngIf="!column.isPagination; else paginationTemplate">
                        {{ column.header }}
                    </ng-container>
                    <ng-template #paginationTemplate>
                        <div *ngIf="!dataMissing && data.length > 0" class="pagination row"><app-pagination
                                [currentPage]="pagination.currentPage" [totalItems]="pagination.totalItems"
                                [pageSize]="pagination.pageSize" (pageChange)="onPageChange($event)"></app-pagination>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="table_body" [style.height]="heightTable.heightBody">
            <div class="no_data fz_l row row_ai_center row_jc_center color_red" *ngIf="dataMissing">{{ typeof dataMissing == 'string' ? dataMissing : 'Данные отсутствуют'}}</div>
            <div class="skeleton_container"><ng-content></ng-content></div>
            <a class="row_hover row_link cursor_pointer" *ngFor="let row of data; let rowIndex = index" routerLink="/{{path}}/{{row.id}}">
                <div class="row fz_s row_ai_center">
                    <div *ngFor="let column of columns; let colIndex = index" [class]="'col-' + column.col">
                        <div class="color_violet text_uppercase"
                            *ngIf="isStatusOrActive(column.field, row); else defaultTemplate">

                            <button class="btn dark_btn" (click)="openModal(row, $event, 'subscription')"
                                *ngIf="column.field == 'btnProlong'; else dynamicText">Продлить</button>
                            <ng-template #dynamicText>
                                {{ getDynamicText(column.field, row) }}
                            </ng-template>
                        </div>
                        <ng-template #defaultTemplate>
                            <div class="flex col row_ai_center">
                                <span *ngIf="addCurrencyToPrice(column, row)">$</span><ng-container
                                    *ngIf="copiedTooltipVisible === (rowIndex + '-' + colIndex); else columnContent">
                                    <span class="color_violet">Скопировано</span>
                                </ng-container>
                                <ng-template #columnContent>
                                    <span [ngClass]="{'color_red' : !(row | tableCell: column)}">{{ (row | tableCell: column) || 'НЕТ ДАННЫХ' }}</span>
                                    <ng-container *ngIf="column.isCopyable">
                                        <ng-container *ngIf="row | tableCell: column as cellValue">
                                            <span class="material-symbols-outlined position-relative fz_l btn_copy"
                                                (click)="copyTextToClipboard(cellValue, rowIndex + '-' + colIndex, $event)">
                                                content_copy
                                            </span>
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
<app-modal-prolong *ngIf="(modalService.modalState$ | async) === 'subscription' && prolong === 'prolong'"
    [subscription]="row" (change)="modalProlong.emit()"></app-modal-prolong>